<template>
  <div>
    <div v-if="!playerIsGM">
      <EntityList
        :aka="'character'"
        :entities="players"
        :entitiesHaveLoaded="entitiesHaveLoaded"
        :selectEntity="onSelectEntity"
        :deleteEntity="deleteEntity"
        />
    </div>
    
    <div v-if="playerIsGM">
       <div class="buttonContainer">
          <button class="waves-effect waves-light btn-large white" type="submit" name="action" @click="roundOne">
            First Round
            <i class="material-icons right">send</i>
          </button>
          <p v-if="feedback">{{ feedback }}</p>
        </div>
      <EntityList
        :aka="'character'"
        :entities="players"
        :entitiesHaveLoaded="entitiesHaveLoaded"
        :selectEntity="toggleActivation"
        :deleteEntity="deleteEntity"
        :playerIsGM="playerIsGM"
        />
      <EntityList
        :aka="'monster'"
        :entities="monsters"
        :entitiesHaveLoaded="entitiesHaveLoaded"
        :selectEntity="toggleActivation"
        :deleteEntity="deleteEntity"
        :playerIsGM="playerIsGM"
        />
      <EntityList
        :aka="'boss'"
        :entities="bosses"
        :entitiesHaveLoaded="entitiesHaveLoaded"
        :selectEntity="toggleActivation"
        :deleteEntity="deleteEntity"
        :playerIsGM="playerIsGM"
        />
      <EntityList
        :aka="'bug'"
        :entities="bugs"
        :entitiesHaveLoaded="entitiesHaveLoaded"
        :selectEntity="toggleActivation"
        :deleteEntity="deleteEntity"
        :playerIsGM="playerIsGM"
        />
      <EntityList
        :aka="'accepted feature'"
        :entities="acceptedFeatures"
        :entitiesHaveLoaded="entitiesHaveLoaded"
        :selectEntity="toggleActivation"
        :deleteEntity="deleteEntity"
        :playerIsGM="playerIsGM"
        />
      <EntityList
        :aka="'idea'"
        :entities="ideas"
        :entitiesHaveLoaded="entitiesHaveLoaded"
        :selectEntity="toggleActivation"
        :deleteEntity="deleteEntity"
        :playerIsGM="playerIsGM"
        />
      <EntityList
        :aka="'resource'"
        :entities="resources"
        :entitiesHaveLoaded="entitiesHaveLoaded"
        :selectEntity="toggleActivation"
        :deleteEntity="deleteEntity"
        :playerIsGM="playerIsGM"
        />
    </div>
  </div>
</template>

<script>
import EntityList from '@/components/EntityList'

export default {
  name: 'ScenarioStart',
  data() {
    return {
      feedback: null
    }
  },
  props: [
    'playerIsGM',
    'entitiesHaveLoaded',
    'players',
    'monsters',
    'bosses',
    'deleteEntity',
    'toggleActivation',
    'bugs',
    'acceptedFeatures',
    'ideas',
    'resources',
    ],
  components: {EntityList},
  methods: {
    onSelectEntity(entity) {
      this.$emit('playerSelectsCharacter', entity)
      console.log('selected', entity.name)
      // this.toggleActivation(entity)
      console.log('✓')
      this.$router.push({ name: 'RoundPrep', params: { entity, name:entity.name } })
    },
    roundOne() {
      this.$emit('watcherdoc-update', 'roundCount', 1)
      this.feedback = "Button is clicked."
    }
  },
}
</script>

<style scoped>
.white{
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/ScenarioStart.vue